import { RouteRecordRaw } from 'vue-router'
import AdminLayout from '@/layouts/AdminLayout.vue'

// 管理后台模块路由
const adminRoutes: RouteRecordRaw = {
  path: '/admin',
  component: AdminLayout,
  meta: {
    title: '管理后台',
    requiresAuth: true,
    requiresAdmin: true
  },
  children: [
    {
      path: '',
      redirect: '/admin/dashboard'
    },
    {
      path: 'dashboard',
      name: 'AdminDashboard',
      component: () => import('@/views/Admin/Dashboard.vue'),
      meta: {
        title: '总览',
        icon: 'dashboard',
        keepAlive: true
      }
    },
    // 用户管理路由
    {
      path: 'user',
      name: 'AdminUser',
      redirect: '/admin/user/list',
      meta: {
        title: '用户管理',
        icon: 'user'
      },
      children: [
        //学员列表
        {
          path: 'studentlist',
          name: 'AdminUserStudentList',
          component: () => import('@/views/Admin/User/StudentList.vue'),
          meta: {
            title: '学员列表',
            keepAlive: true
          }
        },
        //教师列表
        {
          path: 'teacherlist',
          name: 'AdminUserTeacherList',
          component: () => import('@/views/Admin/User/TeacherList.vue'),
          meta: {
            title: '教师列表',
            keepAlive: true
          }
        },
        //管理员列表
        {
          path: 'adminlist',
          name: 'AdminUserAdminList',
          component: () => import('@/views/Admin/User/AdminList.vue'),
          meta: {
            title: '管理员列表',
            keepAlive: true
          }
        },
        //部门管理
        {
          path: 'department',
          name: 'AdminUserDepartment',
          component: () => import('@/views/Admin/User/DepartmentManagement.vue'),
          meta: {
            title: '部门管理',
            keepAlive: true
          }
        },
        //用户列表
        {
          path: 'list',
          name: 'AdminUserList',
          component: () => import('@/views/Admin/User/UserList.vue'),
          meta: {
            title: '角色管理',
            requiresAuth: true
          }
        },
        //角色管理
        {
          path: 'roles',
          name: 'AdminRolePermissions',
          component: () => import('@/views/Admin/User/UserRoles.vue'),
          meta: {
            title: '权限配置',
            requiresAuth: true
          }
        },
        {
          path: 'permissions',
          name: 'AdminUserPermissionsRoot',
          component: () => import('@/views/Admin/User/UserPermissions.vue'),
          meta: {
            title: '权限配置',
            keepAlive: false
          }
        }
      ]
    },
    // 招生管理路由
    {
      path: 'enrollment',
      name: 'AdminEnrollment',
      meta: {
        title: '招生管理',
        icon: 'user'
      },
      children: [
        {
          path: 'plan',
          name: 'AdminEnrollmentPlan',
          component: () => import('@/views/Admin/Enrollment/EnrollmentPlan.vue'),
          meta: {
            title: '招生计划',
            keepAlive: true
          }
        },
        {
          path: 'plan/create',
          name: 'AdminEnrollmentPlanCreate',
          component: () => import('@/views/Admin/Enrollment/EnrollmentPlanCreate.vue'),
          meta: {
            title: '新建招生计划',
            keepAlive: false
          }
        },
        {
          path: 'plan/edit/:id',
          name: 'AdminEnrollmentPlanEdit',
          component: () => import('@/views/Admin/Enrollment/EnrollmentPlanEdit.vue'),
          meta: {
            title: '编辑招生计划',
            keepAlive: false
          }
        },
        {
          path: 'plan/detail/:id',
          name: 'AdminEnrollmentPlanDetail',
          component: () => import('@/views/Admin/Enrollment/EnrollmentPlanDetail.vue'),
          meta: {
            title: '招生计划详情',
            keepAlive: false
          }
        },
        {
          path: 'plan/stats/:id',
          name: 'AdminEnrollmentPlanStats',
          component: () => import('@/views/Admin/Enrollment/EnrollmentPlanStats.vue'),
          meta: {
            title: '报名统计分析',
            keepAlive: false
          }
        },
        {
          path: 'student',
          name: 'AdminEnrollmentStudent',
          component: () => import('@/views/Admin/Enrollment/EnrollmentStudent.vue'),
          meta: {
            title: '招生管理',
            keepAlive: true
          }
        },
    
        {
          path: 'confirm',
          name: 'EnrollmentConfirm',
          component: () => import('@/views/Admin/Enrollment/EnrollmentConfirm.vue'),
          meta: {
            title: '现场确认管理',
            requiresAuth: true
          }
        },
        {
          path: 'confirm/settings',
          name: 'EnrollmentConfirmSettings',
          component: () => import('@/views/Admin/Enrollment/EnrollmentConfirmSettings.vue'),
          meta: {
            title: '现场确认设置',
            requiresAuth: true
          }
        },
        {
          path: 'confirm/batch',
          name: 'EnrollmentConfirmBatch',
          component: () => import('@/views/Admin/Enrollment/EnrollmentConfirmBatch.vue'),
          meta: {
            title: '批量设置确认时间',
            requiresAuth: true
          }
        },
        {
          path: 'confirm/student/:id',
          name: 'EnrollmentStudentDetail',
          component: () => import('@/views/Admin/Enrollment/EnrollmentStudentDetail.vue'),
          meta: {
            title: '学员资料确认',
            requiresAuth: true
          }
        }
      ]
    },
    
    // 课程管理路由
    {
      path: 'course',
      name: 'AdminCourse',
      redirect: '/admin/course/courselist',
      meta: {
        title: '课程管理',
        icon: 'reading'
      },
      children: [
        {
          path: 'courselist',
          name: 'AdminCourseList',
          component: () => import('@/views/Admin/Course/CourseList.vue'),
          meta: {
            title: '课程列表',
            keepAlive: true
          }
        },
       
        {
          path: 'resource',
          name: 'AdminCourseResource',
          component: () => import('@/views/Admin/Course/CourseResource.vue'),
          meta: {
            title: '课程资源',
            keepAlive: true
          }
        },
        {
          path: 'create',
          name: 'AdminCourseCreate',
          component: () => import('@/views/Admin/Course/CourseCreate.vue'),
          meta: {
            title: '新建课程',
            keepAlive: false
          }
        },
        {
          path: 'edit/:id',
          name: 'AdminCourseEdit',
          component: () => import('@/views/Admin/Course/CourseEdit.vue'),
          meta: {
            title: '编辑课程',
            keepAlive: false
          }
        },
        {
          path: 'detail/:id',
          name: 'AdminCourseDetail',
          component: () => import('@/views/Admin/Course/CourseDetail.vue'),
          meta: {
            title: '课程详情',
            keepAlive: false
          }
        }
      ]
    },
    //直播管理路由
    {
      path: 'live',
      name: 'AdminLive',
      redirect: '/admin/live/course',
      meta: {
        title: '直播管理',
        icon: 'video-play'
      },
      children: [
        {
          path: 'course',
          name: 'AdminLiveCourse',
          component: () => import('@/views/Admin/Live/LiveCourse.vue'),
          meta: {
            title: '直播课程',
            keepAlive: true
          }   
        },
        {
          path: 'settings',
          name: 'AdminLiveSettings',
          component: () => import('@/views/Admin/Live/LiveSettings.vue'),
          meta: {
            title: '直播间设置',
            keepAlive: true
          }
        },
        {
          path: 'statistics',
          name: 'AdminLiveStatistics',    
          component: () => import('@/views/Admin/Live/LiveStatistics.vue'),
          meta: {
            title: '直播数据',
            keepAlive: true
          }
        }
      ]
    },
    // 教学管理路由
    {
      path: 'teaching',
      name: 'AdminTeaching',
      redirect: '/admin/teaching/index',
      meta: {
        title: '教学管理',
        icon: 'book'
      },
      children: [
        {
          path: 'index',
          name: 'AdminTeachingIndex',
          component: () => import('@/views/Admin/Teaching/index.vue'),
          meta: {
            title: '教学管理首页',
            requiresAuth: true
          }
        },
        {
          path: 'plan',
          name: 'AdminTeachingPlan',
          component: () => import('@/views/Admin/Teaching/TeachingPlan.vue'),
          meta: {
            title: '教学计划',
            requiresAuth: true
          }
        },
        {
          path: 'schedule',
          name: 'AdminCourseSchedule',
          component: () => import('@/views/Admin/Teaching/CourseSchedule.vue'),
          meta: {
            title: '排课管理',
            requiresAuth: true
          }
        }
      ]
    },
    
    // 题库管理路由
    {
      path: 'question',
      name: 'AdminQuestion',
      redirect: '/admin/question/bank',
      meta: {
        title: '题库管理',
        icon: 'document'
      },
      children: [
        {
          path: 'bank',
          name: 'AdminQuestionBank',
          component: () => import('@/views/Admin/Question/QuestionBank.vue'),
          meta: {
            title: '题目库',
            keepAlive: true
          }
        },
        {
          path: 'paper',
          name: 'AdminExamPaper',
          component: () => import('@/views/Admin/Question/ExamPaper.vue'),
          meta: {
            title: '试卷库',
            keepAlive: true
          }
        },
        {
          path: 'paper/create',
          name: 'AdminExamPaperCreate',
          component: () => import('@/views/Admin/Question/ExamPaperCreate.vue'),
          meta: {
            title: '新建试卷',
            keepAlive: false
          }
        },
        // {
        //   path: 'type',
        //   name: 'AdminQuestionType',  
        //   component: () => import('@/views/Admin/Question/QuestionType.vue'),
        //   meta: {
        //     title: '题型管理',
        //     keepAlive: true
        //   }
        // }
      ]
    },
    //考试管理路由
    {
      path: 'exam',
      name: 'AdminExam',
      redirect: '/admin/exam/schedule',
      meta: {
        title: '考试管理',
        icon: 'document'  
      },
      children: [
        {
          path: 'schedule',
          name: 'AdminExamSchedule',
          component: () => import('@/views/Admin/Exam/ExamSchedule.vue'),
          meta: {
            title: '考试安排',
            keepAlive: true
          }
        },
        {
          path: 'monitor',
          name: 'AdminExamMonitor',
          component: () => import('@/views/Admin/Exam/ExamMonitor.vue'),
          meta: {
            title: '在线监考',
            keepAlive: true
          }
        }
      ]
    },
    // 论文管理路由
    // { path: '/admin/paper/audit', title: '论文审核' },
    // { path: '/admin/paper/defense', title: '答辩管理' },
    // { path: '/admin/paper/ai', title: 'AI文献管理' },
    // { path: '/admin/paper/translate', title: '专业翻译' },
    // { path: '/admin/paper/writing', title: '写作指导' },
    // { path: '/admin/paper/tool', title: '写作工具' },   
    // { path: '/admin/paper/export', title: '排版导出' }    
    {
      path: 'paper',
      name: 'AdminPaper',
      redirect: '/admin/paper/audit', 
      meta: {
        title: '论文审核',
        icon: 'document-checked',
        keepAlive: true
      },
      children: [
        {
          path: 'audit',
          name: 'AdminPaperAudit',
          component: () => import('@/views/Admin/Paper/PaperAudit.vue'),
          meta: {
            title: '论文审核',
            keepAlive: true
          }
        },
        {
          path: 'defense',
          name: 'AdminPaperDefense',
          component: () => import('@/views/Admin/Paper/PaperDefense.vue'),
          meta: {
            title: '答辩管理',
            keepAlive: true
          }
        },
        {
          path: 'ai',
          name: 'AdminPaperAi',
          component: () => import('@/views/Admin/Paper/PaperAi.vue'),
          meta: {
            title: 'AI文献管理',
            keepAlive: true
          }
        },
        {
          path: 'translate',
          name: 'AdminPaperTranslate',
          component: () => import('@/views/Admin/Paper/PaperTranslate.vue'),
          meta: {
            title: '专业翻译',
            keepAlive: true
          }   
        },
        // {
        //   path: 'writing',
        //   name: 'AdminPaperWriting',
        //   component: () => import('@/views/Admin/Paper/PaperWriting.vue'),
        //   meta: {
        //     title: '写作指导',
        //     keepAlive: true
        //   }
        // },
        {
          path: 'tool',
          name: 'AdminPaperTool',
          component: () => import('@/views/Admin/Paper/PaperWrite.vue'),
          meta: {
            title: '写作工具',
            keepAlive: true
          }
        },
        // {
        //   path: 'export',
        //   name: 'AdminPaperExport',
        //   component: () => import('@/views/Admin/Paper/PaperExport.vue'),
        //   meta: {
        //     title: '排版导出',
        //     keepAlive: true
        //   }
        // }
      ]
    },
    //洞察引擎路由
    {
      path: 'insight',
      name: 'AdminInsight',
      component: () => import('@/views/Admin/Insight/Insight.vue'),
      meta: {
        title: '洞察引擎',
        icon: 'document',
        keepAlive: true
      }
    },
    //动态考点趋势比对
    {
      path: 'dynamic',
      name: 'AdminDynamic',
      component: () => import('@/views/Admin/Dynamic/Dynamic.vue'),
      meta: {
        title: '动态考点趋势比对',
        icon: 'trend-charts',
        keepAlive: true
      }
    },
    //数据大屏
    {
      path: 'dataview',
      name: 'AdminDataView',
      component: () => import('@/views/Admin/DataView/DataView.vue'),
      meta: {
        title: '数据大屏',
        icon: 'monitor',
        keepAlive: true
      }
    },
    //AI工具箱路由
    {
      path: 'aitools',
      name: 'AdminAiTool',
      component: () => import('@/views/Admin/AiTool/index.vue'),
      meta: {
        title: 'AI工具箱',
        icon: 'ai',
        keepAlive: true
      },
      children: [
        {
          path: 'index',
          name: 'AdminAiToolIndex',
          component: () => import('@/views/Admin/AiTool/index.vue'),
          meta: {
            title: 'AI工具箱',
            keepAlive: true
          }
        },
        // {
        //   path: 'createlesson',
        //   name: 'AdminAiToolCreateLesson',
        //   component: () => import('@/views/Admin/AiTool/CreateLesson.vue'),
        //   meta: {
        //     title: '智能生成课程',
        //     keepAlive: true
        //   }
        // },
        // {
        //   path: 'createtppt',
        //   name: 'AdminAiToolCreateTppt',
        //   component: () => import('@/views/Admin/AiTool/CreateTppt.vue'),
        //   meta: {
        //     title: '智能生成PPT',
        //     keepAlive: true
        //   }
        // },
        // {
        //   path: 'createquestion',
        //   name: 'AdminAiToolCreateQuestion',
        //   component: () => import('@/views/Admin/AiTool/CreateQuestion.vue'),
        //   meta: {
        //     title: '智能生成题目',
        //     keepAlive: true
        //   }
        // },
        // {
        //   path: 'grader',
        //   name: 'AdminAiToolGrader',
        //   component: () => import('@/views/Admin/AiTool/Grader.vue'),
        //   meta: {
        //     title: '智能批改',
        //     keepAlive: true
        //   }
        // }
   
      ]
    },
    
    // 系统管理路由
    {
      path: 'system',
      name: 'AdminSystem',
      redirect: '/admin/system/settings',
      meta: {
        title: '系统管理',
        icon: 'setting'
      },
      children: [
        // {
        //   path: 'settings',
        //   name: 'AdminSystemSettings',
        //   component: () => import('@/views/Admin/System/SystemSettings.vue'),
        //   meta: {
        //     title: '系统设置',
        //     keepAlive: true
        //   }
        // },
        {
          path: 'logs/operation',
          name: 'AdminSystemOperationLogs',
          component: () => import('@/views/Admin/Logs/OperationLog.vue'),
          meta: {
            title: '操作日志',
            keepAlive: true
          }
        },
        {
          path: 'logs/login',
          name: 'AdminSystemLoginLogs',
          component: () => import('@/views/Admin/Logs/LoginLog.vue'),
          meta: {
            title: '登录日志',
            keepAlive: true
          }
        }
      ]
    },
    
  ]
}

export default adminRoutes 